export default __webpack_public_path__ + "static/media/Done.f9479c31.svg";